import { Components } from "@mui/material/styles/components";
import { Theme } from "@mui/material/styles/createTheme";

const getOverrides = (theme: Theme): Components<NonNullable<unknown>> => ({
  MuiMenuItem: {
    styleOverrides: {
      root: {
        whiteSpace: "inherit",
        wordBreak: "break-word",
        "&:hover": {
          backgroundColor: theme.palette.background.default,
        },
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      asterisk: {
        color: theme.palette.error.main,
      },
    },
  },
  //TODO: need fix errormessage position
  // MuiFormHelperText: {
  //   styleOverrides: {
  //     root: {
  //       position: "absolute",
  //       bottom: "-18px",
  //     },
  //   },
  // },
  /* MuiTextField: {
    styleOverrides: {
      root: {
        "& .MuiInputBase-root.MuiInputBase-sizeSmall": {
          "& + .MuiFormHelperText-root": {
            color: "green",
            position: "absolute",
            bottom: 0
          }
        }
      }
    }
  },*/
  /* MuiFormHelperText: {
    styleOverrides: {
      root: {
        position: "absolute",
        bottom: 0
      }
    }
  },*/
  MuiInputBase: {
    styleOverrides: {
      root: {
        "&.Mui-disabled": {
          backgroundColor: "#f2f2f2",
        },
      },
      sizeSmall: {
        height: "40px",
      },
    },
  },
  MuiListItem: {
    styleOverrides: {
      container: {
        whiteSpace: "inherit",
        wordBreak: "break-word",
      },
    },
  },
  MuiInput: {
    styleOverrides: {
      root: {
        "&.MuiInput-underline": {
          "&&:before": { borderBottom: "none" },
          "&&:after": { borderBottom: "none" },
          "&&:hover:not(.Mui-disabled):before": { borderBottom: "none" },
        },
        "&& .MuiSelect-select": {
          backgroundColor: "white",
          "&:focus": {
            backgroundColor: "white",
          },
          paddingBottom: "10px",
          paddingTop: "10px",
        },
        "&& .MuiSelect-select.Mui-selected": {
          backgroundColor: "white",
          "&:hover": {
            backgroundColor: "white",
          },
        },
      },
    },
  },
  MuiAvatar: {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        fontWeight: 400,
        textTransform: "uppercase",
        fontSize: "16px",
        padding: "8px 22px",
        borderRadius: "4px",
        "&.MuiButton-sizeSmall": {
          fontSize: "13px",
          padding: "4px 10px",
        },
      },
    },
    //TODO example how to create custom variant for button
    // variants: [
    //   {
    //     props: { variant: 'customVariant' },
    //     style: {
    //       backgroundColor: "#fff",
    //       textTransform: 'uppercase',
    //       border: `1px solid #018AF8`,
    //       color: "#018AF8",
    //     },
    //   },
    // ],
  },
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        "&.lightGray": {
          fill: theme.palette.lightGray.main,
        },
        "&.mainColor": {
          fill: theme.palette.primary.main,
        },
      },
    },
  },
  // MuiFilledInput: {
  //   styleOverrides: {
  //     input: {
  //       backgroundColor: theme.palette.background.default,
  //       borderRadius: 4,
  //       color: theme.palette.secondary.dark,
  //       padding: theme.spacing(0.5, 1.25),
  //     },
  //   },
  // },
  // MuiSelect: {
  //   styleOverrides: {
  //     select: {
  //       height: 32,
  //       padding: theme.spacing(0.5, 1.25),
  //       border: `1px solid ${theme.palette.primary.dark}`,
  //       "&: focus-visible": {
  //         borderColor: theme.palette.primary.dark,
  //       },
  //       "&.Mui-disabled": {
  //         borderColor: theme.palette.secondary.main,
  //       },
  //     },
  //     icon: {
  //       width: 20,
  //       color: theme.palette.primary.dark,
  //       "&+fieldset": {
  //         border: `1px solid ${theme.palette.primary.dark}`,
  //       },
  //       "&.Mui-disabled": {
  //         color: theme.palette.secondary.main,
  //       },
  //     },
  //   },
  // },
});

export default getOverrides;
